<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-filter-item-checkbox" v-if="filter">
    <el-dropdown-item class="checkbox-item">
      <span class="filter-title">{{filter.label}}:</span>
      <el-checkbox-group v-model="filter.value" :min="1">
        <el-checkbox v-for="item in filter.dataSource" :label="item.key" :key="item.key" :class="item.key" @change="handleChange(item)">{{item.label}}</el-checkbox>
      </el-checkbox-group>
    </el-dropdown-item>
  </div>
</template>

<script>
export default {
  name: 'wy-filter-item-checkbox',
  props: ["filter"],

  methods: {
    handleChange(item) {
      if(this.filter.isRequire) {
        if(this.filter.value.length == 0) {
          this.filter.value.push(item.key)
        }
      }
    },
  }
}
</script>

<style lang="scss">
.wy-header-menu-filtering-panel-ca label.el-checkbox:hover, 
.wy-header-menu-filtering-panel-op label.el-checkbox:hover{
  background:var(--top-menu-panel-global-filter-checkbox-text-hover-background-color) !important;
  border-radius: 5px;
  padding-left: 14px;
  width: 224px;
  span.el-checkbox__inner{
     background: var(--top-menu-panel-global-filter-checkbox-button-checked-background-color) !important; 
  }
}

.wy-header-menu-filtering-panel-ca label.el-checkbox.is-checked, 
.wy-header-menu-filtering-panel-op label.el-checkbox.is-checked{
  background: var(--top-menu-panel-global-filter-checkbox-text-selected-background-color);
  border-radius: 5px;
  padding-left: 14px;
  width: 224px;
  span.el-checkbox__inner{
    background: var(--top-menu-panel-global-filter-checkbox-text-selected-background-color) !important; 
  }
}

.wy-header-menu-filtering-panel-ca .filter-section.languages label.el-checkbox {
  padding-bottom: 1px;
  padding-top: 10px;
  margin-bottom: 29px;
  padding-left: 14px;
  margin-right: 10px;
}

.wy-header-menu-platforms-panel label.el-checkbox:hover{
  // background:#353E43;
  background: var(--top-menu-panel-global-filter-checkbox-text-hover-background-color) !important;
  border-radius: 5px;
  padding-left: 14px;
  margin-top: 9px;
  padding-bottom: 1px;
  width: 261px;
  span.el-checkbox__inner{
    background: var(--top-menu-panel-global-filter-checkbox-button-checked-background-color) !important; 
  }
}
.wy-header-menu-platforms-panel label.el-checkbox.is-checked{
  // background: #1B262B;
  background: var(--top-menu-panel-global-filter-checkbox-text-selected-background-color);
  border-radius: 5px;
  padding-left: 14px;
  width: 261px;
  height: 33px;
  padding-bottom: 1px;
  margin-top: 10px;
  span.el-checkbox__inner{
    background: var(--top-menu-panel-global-filter-checkbox-text-selected-background-color) !important; 
  }
}
</style>